module.exports = __webpack_public_path__ + "img/f5.bf2ec72d.png";